import * as React from "react";

export const Filter: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M8.124 10.439c0-.2-.096-.388-.257-.505L4.66 7.589a.67.67 0 0 1-.284-.537V5.065c0-.35.31-.69.764-.69h9.722c.454 0 .764.34.764.69v1.987a.67.67 0 0 1-.284.537l-3.208 2.345a.63.63 0 0 0-.257.505v3.44a.69.69 0 0 1-.41.611h0L9.24 15.544h0c-.558.264-1.117-.145-1.117-.611z"
    ></path>
  </svg>
);
